export enum ModalTestId {
  MODAL_TEST_ID_CANCEL = 'modal-test-id-cancel',
  MODAL_TEST_ID_OK = 'modal-test-id-ok',
}
